/**
 * This behavior is for the Health Care Professional Compliance pop-up.
 * It sticks to the top of the page until accepted by the user.
 * The default before the cookie expires is 30 days.
 */

(function($, Drupal){
  Drupal.behaviors.hcpCompliance = {
    attach(context, settings){
      let $navbar = $('header.navbar-fixed-top', context);
      let hcpCompliance = this;
      const $disclaimerButton = $('.disclaimer-button input', context);
      const expirationDays = $disclaimerButton.data('expirationdays');
      const $compliancePopup = $('.hcp-disclaimer', context);

      // Show the HCP compliance pop up if the user hasn't agree or the cookie expired
      // The compliance pop-up is hidden by default
      if(!this.hasAgreed('hcpCompliance')){
        $compliancePopup.show();

        // Style the navbar for Mobile and Desktop
        this.styleNavbar($navbar);

        // When clicked, hide Compliance pop-up and set cookie
        $disclaimerButton.on('click', function removeStickyStyling(){
          // Set the cookie to expire in amount of days set in Drupal
          this.setCookie('hcpCompliance', 'accepted', expirationDays);

          // Remove style for navbar
          $navbar.removeAttr('style');

          // Hide compliance popup
          $compliancePopup.hide();

          // Turn off unneeded events
          $(window).off('orientationchange');
        }.bind(this));

        // Handle navbar style when rotating mobile devices
        $(window).on('orientationchange',function handleOrientationChange(){
          setTimeout(function(){
            hcpCompliance.styleNavbar($navbar);
          }, 300);

        });
      }
    },
    /**
    * Gets the cookie value by name
    * @param cookieName{string}
    * @returns {string}
    */
    getCookie: function(cookieName){
      var name = cookieName + "=",
      decodedCookie = decodeURIComponent(document.cookie),
      cookieArray = decodedCookie.split(';'),
      i;

      for(i = 0; i < cookieArray.length; i++){
        var cookie = cookieArray[i];
        while(cookie.charAt(0) == ' '){
          cookie = cookie.substring(1);
        }
        if(cookie.indexOf(name) == 0){
          return cookie.substring(name.length, cookie.length);
        }
      }
      return "";
    },
    /**
    * Sets the cookie with the given name/value pair and expiration in days
    * @param cookieName{string}
    * @param cookieValue
    * @param expirationDays{number}
    */
    setCookie: function(cookieName, cookieValue, expirationDays){
      let date = new Date();
      date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + date.toUTCString();

      document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    },
    /**
    * Returns true if the user has clicked to agree the compliance pop-up,
    * Otherwise returns false
    * @param cookieName{string}
    * @returns {boolean}
    */
    hasAgreed: function(cookieName){
      const cookie = this.getCookie(cookieName);

      return cookie ? true : false
    },
    /**
    * Checks if the device is a mobile device
    * @returns {boolean}
    */
    isMobileDevice: function(){
      return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    },
    /**
    * Styles the navbar bellow the compliance pop-up
    * @param $navbar{jQuery element}
    */
    styleNavbar: function($navbar){
      if(this.isMobileDevice()){
        const viewportWidth = $(document).width();

        if(viewportWidth > 1079){
            $navbar.css({'top': '7rem'});
        }else if(viewportWidth > 1023){
            $navbar.css({'top': '8rem'});
        }else if(viewportWidth > 619){
            $navbar.css({'top': '10rem'});
        }else{
            $navbar.css({'top': '14.5rem'});
        }
      }
      // Style navbar for Desktop
      else{
          $navbar.css({'top': '6rem'});
      }
    }
  };
}(jQuery, Drupal));
